import { makeMemberQuery } from "@web-monorepo/fetchers";

export const useApiFeatureSwitchesFetcher = makeMemberQuery({
  fetcherName: "featureSwitches",
  path: "/api/featureSwitch/v2",
  queryParams: [
    "appVersion",
    "featureSetId",
    "parentCountryCode",
    "parentId",
    "parentLocale",
    "parentSwitches",
    "school0Id",
    "school0Switches",
    "school1Id",
    "school1Switches",
    "school2Id",
    "school2Switches",
    "school3Id",
    "school3Switches",
    "school4Id",
    "school4Switches",
    "school5Id",
    "school5Switches",
    "school6Id",
    "school6Switches",
    "school7Id",
    "school7Switches",
    "school8Id",
    "school8Switches",
    "school9Id",
    "school9Switches",
    "schoolCountryCode",
    "schoolId",
    "schoolIsMentor",
    "schoolLocale",
    "schoolSwitches",
    "sessionId",
    "sessionSwitches",
    "studentId",
    "studentLocale",
    "studentSwitches",
    "teacherCountryCode",
    "teacherId",
    "teacherIsDojoian",
    "teacherIsMentor",
    "teacherLocale",
    "teacherSwitches",
    "tutorCountryCode",
    "tutorId",
    "tutorSwitches",
  ],
});
